import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"col\"><h1>Who Am I?</h1><div class=\"border-start ps-3 mt-4 border-3\"><p> You may have heard of me from <a href=\"https://osu.ppy.sh/\" class=\"text-decoration-none\">osu!mania</a>. I&#39;m a mapper there </p><p> I&#39;m a <span class=\"fw-bold\">Data Magician</span>! I have a passion in transforming data! </p><p>I too enjoy designing &amp; photography on the side :D</p></div><h2>More details on the top navigation bar!</h2><p>Many pages are still under construction, please wait o wo)&#39;</p></div>", 1)
const _hoisted_5 = { class: "col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseImage = _resolveComponent("BaseImage")!
  const _component_Header = _resolveComponent("Header")!
  const _component_HomeTopics = _resolveComponent("HomeTopics")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_BaseImage, { title: "Good Evening." }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Header, { subtitle: "Thanks for visiting!" }, {
          default: _withCtx(() => [
            _createTextVNode("o wo)n~")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_HomeTopics, {
            class: "border-bottom",
            title: _ctx.title,
            content: _ctx.content
          }, null, 8, ["title", "content"])
        ])
      ])
    ])
  ]))
}